module.exports = __webpack_public_path__ + "images/ba24b4397687e8982a763eb5d735a0f4-companylogo.png";